import { Link } from 'react-router-dom';

const SignInPage3 = ({msg, history}:any) =>{
    return (
        <>
            <div className="wrap-body-center">


                <div className="bg"></div>
                <div className="join-step">
                    <div className="join-step-head">
                        <div className="left">
                            <h2>회원가입</h2>
                        </div>
                        <div className="right">
                            <div className="step-status">
                                <ul className="clearfix">
                                    <li className="step-li"><span className="num">1</span> <span className="step-txt">약관동의</span></li>
                                    <li className="step-li"><span className="num">2</span> <span className="step-txt">정보입력</span></li>
                                    <li className="step-li active"><span className="num">3</span> <span className="step-txt">회원가입 완료</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="join-step-body">
                        <div className="">
                            <fieldset>
                                <p className="reg_complete">
                                    ECOS 경제통계시스템<br />
                                    회원가입이 완료되었습니다.
                                </p>
                            </fieldset>
                        </div>
                        <div className="btn-group btn-130">
                            <button className="btn btn-popup positive" onClick={() => history.push('/')}>메인</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default SignInPage3;